// src/components/sacred/ArabicMotif.jsx
// Single decorative render of the brand zellige tile (the same SVG used
// as the global tessellation background). Recolorable via `color` —
// renders the SVG as a CSS mask so any color from the design tokens
// works (currentColor, var(--sacred-primary), '#fff', etc.).
//
// Replaces the legacy hand-drawn 8-pointed star paths that used to live
// inline in Welcome / Login / Register / Lawh.

import React from 'react';
import { Box } from '@mui/material';

const MOTIF_URL = `${process.env.PUBLIC_URL || ''}/motifs/zellige.svg`;

const ArabicMotif = React.forwardRef(function ArabicMotif(
  { color = 'currentColor', sx, ...rest },
  ref,
) {
  return (
    <Box
      ref={ref}
      aria-hidden
      sx={{
        width: '100%',
        height: '100%',
        backgroundColor: color,
        WebkitMaskImage: `url(${MOTIF_URL})`,
        maskImage: `url(${MOTIF_URL})`,
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        pointerEvents: 'none',
        ...sx,
      }}
      {...rest}
    />
  );
});

export default ArabicMotif;
